import http from "infra/http";
import { useQuery } from "react-query";
import { NotificacaoConfiguracaoResponse } from "../typings";

function useNotificacaoCobranca() {
  return useQuery([`/v1/notificacao-cobranca`], async () => {
    const { data } = await http.get<NotificacaoConfiguracaoResponse>(
      `/v1/notificacao-cobranca`
    );
    return data;
  });
}

export default useNotificacaoCobranca;
